import { UserRole } from './roles'

export const pages = Object.freeze({
  DASHBOARD: '/dashboard',
  LIST_RFQ: '/rfqlist',
  LIST_QCF: '/qcflist',
  LIST_SETTINGS: '/settings',
  MAPPING_MATERIAL: '/mapping-material',
  MASTER_USER: '/master-data/master-user',
  USER_MATRIX: '/master-data/user-matrix',
  MASTER_DIVISION: '/master-data/master-divisions',
  MASTER_HIERARCHY: '/master-data/material-hierarchy',
  MASTER_ASSIGNMENT: '/master-data/material-assignment',
  MATRIX_CATEGORY: '/master-data/matrix-category',
  MASTER_CATEGORIES: '/master-data/categories',
})

/** @type {import(".").RoleMapping} */
export const roleMapping = {
  [UserRole.ADMIN]: {
    role: 'Admin',
    navigation: [
      pages.LIST_SETTINGS,
      pages.MAPPING_MATERIAL,
      pages.MASTER_USER,
      pages.USER_MATRIX,
      pages.MASTER_DIVISION,
      pages.LIST_QCF,
      pages.LIST_RFQ,
      pages.MASTER_HIERARCHY,
      pages.MASTER_ASSIGNMENT,
      pages.MASTER_CATEGORIES,
      pages.MATRIX_CATEGORY,
      pages.MASTER_CATEGORIES,
    ],
  },
  [UserRole.CL]: {
    role: 'CL',
    navigation: [pages.LIST_QCF],
  },
  [UserRole.CS]: {
    role: 'CS',
    navigation: [pages.DASHBOARD],
  },
  [UserRole.USER]: {
    role: 'User',
    navigation: [pages.DASHBOARD],
  },
  [UserRole.MANAGEMENT]: {
    role: 'Management',
    navigation: [pages.LIST_QCF],
  },
  [UserRole.VENDOR]: {
    role: 'Vendor',
    navigation: [pages.DASHBOARD],
  },
  [UserRole.DIC]: {
    role: 'DIC',
    navigation: [pages.DASHBOARD],
  },
}
